export const FlexibleYugi = () => (
  <svg
    role="img"
    aria-labelledby="flexibleYugi-title"
    viewBox="0 0 544 720"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="flexibleYugi-title">Yugi the giraffe showing his flexibility</title>
    <path
      d="M236.117 86H12.883C9.5 86 7.74 81.9 10.04 79.52c7.171-7.272 20.294-18.247 35.989-20.098 23.811-2.645 42.752-3.306 51.546-9.257C106.236 44.215 130.319 22 163.195 22c12.853 0 23.271 10.843 28.141 21.686 4.871 10.843 12.447 14.678 24.894 18.38 7.847 2.38 16.912 11.24 22.73 17.455 2.3 2.512.541 6.479-2.842 6.479zM421.916 141h110.168c1.669 0 2.537-2.05 1.402-3.24-3.539-3.636-10.015-9.124-17.76-10.049-11.752-1.323-21.099-1.653-25.439-4.628-4.273-2.976-16.158-14.083-32.383-14.083-6.343 0-11.484 5.421-13.888 10.843-2.403 5.421-6.142 7.339-12.285 9.19-3.873 1.19-8.346 5.62-11.217 8.727-1.135 1.257-.267 3.24 1.402 3.24z"
      fill="#E3F7FC"
    />
    <ellipse cx="271.5" cy="651" rx="150.5" ry="12" fill="#CAF8E8" />
    <path
      d="M179.503 154.297l183.472 29.186-33.832 433.611-178.884-46.451 29.244-416.346z"
      fill="#EAE1FF"
    />
    <path
      opacity=".55"
      d="M295.517 204.448l-3.493 42.409-15.204-38.161c5.479-3.7 11.985-5.344 18.697-4.248z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      opacity=".69"
      d="M323.938 249.186c-.068 1.028-.205 2.055-.342 3.083v.137l-31.435-5.549 3.493-42.409c17.327 2.877 30.133 22.951 28.284 44.738z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      d="M323.527 252.406c-3.081 19.937-17.943 33.16-34.379 30.077-17.122-3.22-29.518-23.02-27.805-44.327 1.027-13.018 7.054-23.774 15.546-29.46l15.204 38.161 31.434 5.549z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      d="M323.596 252.406h-.137v-.137l.137.137z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      opacity=".58"
      d="M208.061 450.131l-16.368-4.453c-1.918-.48-3.287-2.809-3.082-5.207l1.849-25.897c.137-2.398 1.849-3.906 3.767-3.426l16.436 4.248c1.918.479 3.356 2.809 3.151 5.207l-1.918 26.034c-.274 2.466-1.986 3.974-3.835 3.494zM240.317 458.832l-16.71-4.522c-1.918-.548-3.356-2.877-3.15-5.207l1.301-17.128c.205-2.398 1.917-3.905 3.835-3.425l16.71 4.385c1.918.479 3.356 2.877 3.219 5.275l-1.369 17.265c-.137 2.398-1.918 3.905-3.836 3.357zM273.259 467.739l-16.985-4.591c-1.986-.548-3.424-2.877-3.218-5.275l2.534-32.338c.205-2.398 1.917-3.973 3.903-3.425l17.122 4.385c1.986.479 3.424 2.877 3.218 5.343l-2.67 32.475c-.206 2.398-1.918 3.905-3.904 3.426zM306.817 476.782l-17.327-4.659c-1.986-.548-3.424-2.946-3.219-5.344l4.521-54.603c.205-2.467 1.986-4.043 4.04-3.495l17.464 4.385c2.055.48 3.493 2.946 3.287 5.413l-4.725 55.015c-.274 2.329-2.055 3.836-4.041 3.288z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      opacity=".6"
      d="M179.914 545.842l63.417 15.347c1.781.411 3.356-.96 3.561-3.152l4.52-52.823c.206-2.192-1.095-4.316-2.944-4.727L184.571 486.1c-1.713-.411-3.288 1.027-3.425 3.22l-4.04 51.863c-.137 2.193 1.095 4.248 2.808 4.659z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      d="M181.146 489.799l31.641 40.285c1.095 1.37 2.739 1.713 3.972.822l34.653-25.212"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      opacity=".79"
      d="M271.821 336.127l-3.15 38.915-16.094-3.494c-3.425-.754-5.89-4.796-5.616-9.044l2.397-30.967 22.463 4.59z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      opacity=".51"
      d="M319.076 345.788l-2.671 31.515c-.342 4.316-3.561 7.262-7.054 6.44l-40.612-8.769 3.151-38.915 47.186 9.729z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      opacity=".79"
      d="M320.446 329.961l-1.37 15.827-21.436-4.385 1.986-23.637 14.999 2.946c3.561.754 6.163 4.865 5.821 9.249z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <path
      opacity=".51"
      d="M299.626 317.766l-1.986 23.637-48.214-9.866 1.233-15.552c.342-4.316 3.424-7.262 6.848-6.577l42.119 8.358z"
      fill="#fff"
      stroke="#EAE1FF"
      strokeWidth="5"
      strokeMiterlimit="10"
    />
    <g opacity=".9">
      <path
        opacity=".68"
        d="M212.375 227.947c5.548 1.165 10.547-3.631 11.026-10.688.548-7.056-3.561-13.702-9.177-14.867-5.547-1.096-10.478 3.7-10.957 10.757-.48 6.988 3.561 13.634 9.108 14.798z"
        fill="#fff"
        stroke="#EAE1FF"
        strokeMiterlimit="10"
      />
      <g opacity=".68">
        <path
          d="M218.129 216.163l-9.588-1.918 9.588 1.918zm-4.384-7.125l-.89 12.195z"
          fill="#fff"
        />
        <path
          d="M213.745 209.038l-.89 12.195m5.274-5.07l-9.588-1.918 9.588 1.918z"
          stroke="#EAE1FF"
          strokeWidth="5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g opacity=".9">
      <path
        opacity=".68"
        d="M210.047 259.737c5.547 1.164 10.478-3.494 11.026-10.551s-3.561-13.702-9.108-14.867c-5.548-1.165-10.41 3.562-10.958 10.619-.548 6.988 3.561 13.566 9.04 14.799z"
        fill="#fff"
        stroke="#EAE1FF"
        strokeMiterlimit="10"
      />
      <g opacity=".68">
        <path d="M216.074 248.09l-10.205-2.124z" fill="#fff" />
        <path
          d="M216.074 248.09l-10.205-2.124"
          stroke="#EAE1FF"
          strokeWidth="5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <path
      d="M324.144 638.47c39.722-3.426 39.721-25.281 39.721-25.281l35.681-430.87c1.37-16.512-10.409-31.242-26.846-33.434-43.146-5.892-121.219-16.649-142.998-19.732-5.342-.753-10.82-.959-16.231-.548l-27.873 1.576 181.281 42.546-33.558 430.597-9.177 35.146z"
      fill="#956AFF"
    />
    <path
      d="M378.453 180.537c-2.192-11.578-10.478-21.033-20.888-22.746l-4.863-.753-8.492-1.371-8.424-1.37L188.2 130.386c-11.985-1.918-22.532 8.427-23.559 23.089l-22.669 330.501-1.095 16.169-1.37 19.594-2.945 43.505c-.479 6.851 1.37 13.634 4.726 19.183 3.492 5.755 8.629 10.071 14.518 11.716l163.407 43.642c12.533 3.357 23.696-5.687 24.929-20.28l34.859-428.061c.205-3.015 0-6.029-.548-8.907zm-56.569 410.386c-.685 8.564-7.191 13.908-14.519 11.989L171.353 567.56c-6.438-1.713-11.369-8.975-11.437-16.648 0-.548 0-1.028.068-1.576l5.068-72.965 1.37-19.457 1.164-16.375 18.286-262.605c.616-8.633 6.848-14.73 13.971-13.497l118.206 19.937 8.355 1.439 8.561 1.438 5.204.891c7.602 1.302 13.15 9.592 12.465 18.567l-1.644 20.485-29.106 363.729z"
      fill="#C7B4FD"
    />
    <g opacity=".15" fill="#fff">
      <path
        opacity=".15"
        d="M344.21 155.667l-17.806 30.146-160.051 271.101-25.476 43.231 1.095-16.169 25.546-43.437 150.531-256.165 17.738-30.077 8.423 1.37zM378.453 180.537l-27.531 46.588-191.075 323.718-18.628 31.584c-3.356-5.549-5.205-12.332-4.725-19.183l2.945-43.505 25.476-43.368 169.981-289.12 17.738-30.213 4.862.753c10.547 1.713 18.765 11.168 20.957 22.746z"
      />
    </g>
    <path
      opacity=".14"
      d="M282.505 423.959H259.22c-15.752 0-28.627 12.881-28.627 28.638v46.177h-.137s-12.328 20.485-7.328 24.253c5.068 3.769 9.725-7.673 9.725-7.673s1.369 19.252 8.286 17.608c6.918-1.576.822-19.663.822-19.663s5.342 9.728 9.931 5.96c4.246-3.494-6.712-18.018-8.356-20.211.069-.137 0-.205-.136-.342v-46.383c0-8.632 6.985-15.689 15.683-15.689h7.054c-3.151 4.59-4.931 10.003-4.931 15.689v51.11c0 5.138.205 10.345.548 15.484l7.191 105.302 31.024 8.427 5.341-111.537c0-5.481 4.452-9.934 9.931-9.934 0 0 81.977-134.694 70.882-170.8-2.191-7.194 9.451 69.197-103.618 83.584z"
      fill="#956AFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M288.873 422.247c-.616.137-1.164.342-1.78.479l-.89-.137c0-.068.959-.137 2.67-.342z"
      fill="#FD0"
    />
    <path
      opacity=".14"
      d="M276.82 144.089c-5.067-4.796-18.833-14.73-28.9-21.924 0 0-47.529 10.346-43.009 12.058-12.054 12.332-31.435 24.459-44.584 38.093-25.751 26.72-4.041 103.247-4.041 103.247 1.233-49.397 33.832-72.896 49.72-83.31a83.96 83.96 0 016.575-3.974c.548-.274.959-.411.959-.411h-.069.069l22.463 6.509 13.697 3.973c.069 0 .617.206.685.206 14.45 4.179 30.065-1.439 38.489-13.908.068-.137.137-.205.205-.343.069-.068.069-.137.137-.205 8.013-13.497-1.232-29.529-12.396-40.011z"
      fill="#956AFF"
    />
    <path
      d="M236.072 72.289c.821-1.508 2.191-2.535 3.835-2.81l2.054-.342a5.311 5.311 0 014.589 1.233c1.301 1.096 1.917 2.74 1.849 4.385l-.137 2.672c0 .342 0 .685.137 1.028l.342.89c.48 1.234.891 2.535 1.165 3.906l1.095 9.317 7.808-4.933.137-.068a24.953 24.953 0 013.698-1.576l.89-.274c.343-.137.617-.274.959-.617l1.918-1.781a5.146 5.146 0 014.588-1.302 5.236 5.236 0 013.835 2.81l.959 1.78c.822 1.508.891 3.22.274 4.796-.616 1.576-1.986 2.672-3.63 3.152l-2.602.685c-.342.069-.685.206-.959.48l-.685.616a16.023 16.023 0 01-3.355 2.261l-8.013 3.426c-3.151 1.301-5.616 3.905-7.602 7.81-.617 1.165-1.781 3.631-1.781 3.631l-3.493 7.399-10.683-5.275 3.698-7.262s1.164-2.467 1.712-3.7c1.781-4.042 2.192-7.536 1.301-10.825l-2.328-8.153-.069-.205c-.205-1.302-.342-2.672-.342-4.042v-.96c0-.342-.069-.685-.274-1.096l-1.027-2.398c-.685-1.438-.617-3.151.137-4.658z"
      fill="#733E00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M287.915 176.975c-.068.068-.068.137-.137.205-.068.137-.137.206-.205.343-8.424 12.469-24.039 18.087-38.489 13.908-.069 0-.617-.206-.685-.206l-13.697-3.974-22.463-6.508h-.069c-.205.068-.411.205-.685.342-1.575.891-3.903 2.193-6.711 4.042-15.889 10.414-46.981 37.065-48.214 86.462l-.616 8.085-.48 6.988-1.781 25.829s-25.75-14.799-31.845-53.302c-4.794-36.517 11.437-67.21 37.187-93.998 13.15-13.634 32.531-25.692 44.584-38.093-4.451-1.713-8.629-3.905-11.026-6.714-4.931-5.892-6.369-11.305-6.78-18.978-.411-7.673 1.644-15.278 1.918-22.951 5.41 1.575 11.437 3.357 16.162 4.932 5.616 1.919 11.095 5.002 14.245 10.003 2.329 3.631 4.109 7.536 4.794 11.784 3.288-.411 6.643.274 9.588 1.85l3.972 2.124 6.849 3.7c.616.342 1.164.685 1.712 1.027.548.343 1.096.754 1.644 1.165 10.067 7.194 23.833 17.128 28.901 21.924 11.094 10.482 20.408 26.514 12.327 40.011z"
      fill="#FD0"
    />
    <path
      d="M245.523 138.813c-1.302-1.233-3.082-2.055-4.863-1.849a6.58 6.58 0 00-4.041 2.055c-1.027 1.165-3.013.48-2.876-1.096v-.069c.342-3.083 2.466-5.823 5.41-6.782 5-1.645 9.999 1.644 10.616 6.645a9.696 9.696 0 010 1.987c-.206 1.507-2.192 1.987-2.945.685-.343-.548-.754-1.027-1.301-1.576z"
      fill="#36393B"
    />
    <path
      d="M212.239 180.743s-14.108-3.837-14.108-17.197c0 0-1.849 10.825 6.643 21.582 3.219-2.535 7.465-4.385 7.465-4.385z"
      fill="#E5C500"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M155.943 279.674l-.479 6.988c-.616.411-1.37.617-2.192.617a4.225 4.225 0 01-4.246-4.248 4.225 4.225 0 014.246-4.248c1.028-.068 1.987.274 2.671.891zM135.192 233.908c-3.492 0-6.369 2.877-6.369 6.372 0 3.494 2.877 6.371 6.369 6.371 3.493 0 6.37-2.877 6.37-6.371-.069-3.563-2.877-6.372-6.37-6.372z"
      fill="#C78800"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M421.736 356.681c-.343 5.138-1.096 10.414-2.192 15.689-4.246 20.074-14.245 40.97-31.982 61.25-2.808 3.22-4.178 7.536-4.315 11.852-1.301 32.201-3.904 153.604-4.52 182.173-.069 2.878-.137 4.796-.137 5.618-.753-.548-1.781-.754-2.74-.548l-25.75 5.07h-.137c-.411.068-.89.274-1.233.548l-.342-3.974-9.657-107.974c-.479-6.783-4.451-9.935-9.93-9.935h-20.614c-5.479 0-9.931 4.454-9.931 9.935l-4.862 101.192-.274 5.549c-.753-.48-1.712-.685-2.671-.48l-25.751 5.07c-.136 0-.273.069-.342.069a3.798 3.798 0 00-1.164.616l-.274-3.905-8.081-110.372c-.343-5.139-.548-10.277-.548-15.484v-51.11c0-5.686 1.78-11.099 4.931-15.689h-7.054c-8.63 0-15.684 6.988-15.684 15.689v46.383c.137.137.137.205.069.342-.137-.137-.206-.274-.206-.274H223.47v-46.177c0-15.757 12.875-28.637 28.627-28.637h23.285c4.589-.412 10.479-.891 17.19-1.782 3.698-.479 7.67-1.096 11.711-1.85 31.366-5.892 71.567-22.197 80.471-74.335.616-3.494 1.027-7.125 1.369-10.962v-.205l2.192-26.514 3.493-41.861s10.341 12.812 16.231 23.088c.548 1.028 1.095 1.987 1.575 2.878 1.507 2.946 2.876 5.892 4.109 9.043 6.095 15.073 9.246 32.064 8.013 50.014z"
      fill="#FD0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M237.167 498.774s.069.069.206.275c-.616 1.439-14.93 1.85-13.081-.138v-.137h12.875zM293.873 627.851l-.137 2.809c0 12.126-4.588 20.279-16.71 20.279-3.356 0-5.822.137-7.671 0-4.657-.274-4.931-1.987-4.931-10.756l-.548-7.057c.411-.342.959-.548 1.507-.685l25.751-5.138c1.027-.069 1.986.068 2.739.548zM379.411 627.988v.616c0 12.127-5.067 16.991-17.189 16.991 0 0-11.027 2.535-12.122-6.44l-.548-6.098c.411-.274.822-.479 1.369-.548l25.751-5.138c.959-.206 1.918.069 2.739.617z"
      fill="#FD0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M382.562 650.939h-32.256a3.657 3.657 0 01-3.63-4.111l1.301-11.236a3.625 3.625 0 011.575-2.603c.411-.274.822-.48 1.37-.548l25.75-5.138c1.028-.206 1.987 0 2.74.548.616.411 1.164 1.096 1.438 1.918l5.205 16.306c.685 2.466-1.027 4.864-3.493 4.864zM297.16 650.939h-32.256a3.657 3.657 0 01-3.63-4.111l1.301-11.236c.137-1.027.617-1.918 1.438-2.466.411-.343.959-.548 1.507-.685l25.751-5.138c.958-.206 1.849-.001 2.671.479.684.411 1.301 1.165 1.575 1.987l5.205 16.306c.684 2.466-1.096 4.864-3.562 4.864z"
      fill="#C78800"
    />
    <path
      d="M245.728 519.259c-4.589 3.769-9.93-5.96-9.93-5.96s6.095 18.087-.822 19.663c-6.917 1.576-8.287-17.608-8.287-17.608s-4.725 11.442-9.725 7.674c-5.068-3.769 7.328-24.254 7.328-24.254h12.944s.068.069.205.274c1.575 2.124 12.465 16.717 8.287 20.211z"
      fill="#C78800"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M359.414 401.967c-2.329 0-4.247 1.918-4.247 4.248 0 2.329 1.918 4.247 4.247 4.247 2.328 0 4.246-1.918 4.246-4.247a4.224 4.224 0 00-4.246-4.248zM391.807 345.788c0 3.083-2.534 5.686-5.616 5.686a8.37 8.37 0 01-1.369-.137c.616-3.494 1.027-7.125 1.369-10.962v-.205c3.151-.069 5.616 2.466 5.616 5.618zM393.109 385.661a5.672 5.672 0 00-5.685 5.687 5.671 5.671 0 005.685 5.686c3.15 0 5.615-2.535 5.615-5.686.069-3.152-2.465-5.687-5.615-5.687zM421.736 356.681c-.343 5.138-1.096 10.414-2.192 15.689-.548.069-1.027.137-1.575.137-4.657 0-8.355-3.768-8.355-8.358a8.346 8.346 0 018.355-8.359c1.37 0 2.671.343 3.767.891zM413.723 306.736c-1.165.89-2.603 1.438-4.109 1.438a6.753 6.753 0 01-6.781-6.782c0-3.22 2.192-5.892 5.205-6.577.548 1.027 1.096 1.987 1.576 2.877a107.824 107.824 0 014.109 9.044zM350.579 439.306c3.561-3.562 9.52-3.425 12.875.411 3.082 3.563 2.671 8.975-.616 12.264l-10.547 10.551a2.479 2.479 0 01-3.492 0l-10.547-10.551c-3.356-3.357-3.698-8.77-.617-12.264 3.425-3.836 9.383-3.973 12.944-.411zM316.131 455.132a4.83 4.83 0 00-5.411 4.043 4.831 4.831 0 004.041 5.412c2.602.411 4.999-1.439 5.41-4.042a4.708 4.708 0 00-4.04-5.413zM272.3 439.717a4.83 4.83 0 00-5.41 4.042 4.83 4.83 0 004.04 5.413c2.603.411 5-1.439 5.411-4.042.342-2.604-1.438-5.07-4.041-5.413zM285.723 456.297c-4.588-.685-8.834 2.535-9.519 7.125-.685 4.591 2.534 8.838 7.122 9.455 4.589.685 8.835-2.535 9.451-7.125.685-4.522-2.465-8.77-7.054-9.455zM307.707 433.62c-.685 4.59-4.862 7.742-9.451 7.125-4.588-.685-7.739-4.933-7.122-9.454a9.107 9.107 0 011.506-3.769 215.376 215.376 0 0011.711-1.849c2.397 1.712 3.767 4.727 3.356 7.947zM325.513 424.097c-3.081-.412-5.958 1.712-6.437 4.795-.411 3.083 1.712 5.961 4.794 6.372 3.082.411 5.958-1.713 6.369-4.796.548-3.083-1.575-5.96-4.726-6.371z"
      fill="#C78800"
    />
  </svg>
);
